/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerFindRoleHoldersQueryResponse, PrincipalRolesControllerFindRoleHoldersQueryParams, PrincipalRolesControllerFindRoleHolders401, PrincipalRolesControllerFindRoleHolders403 } from "../../models/principalRolesController/PrincipalRolesControllerFindRoleHolders";

function getPrincipalRolesControllerFindRoleHoldersUrl() {
  const res = { method: 'GET', url: `/api/v1/principal-roles/role-holders` as const }  
  return res
}

/**
 * @summary List who holds each of a set of roles at a scope
 * {@link /api/v1/principal-roles/role-holders}
 */
export async function principalRolesControllerFindRoleHolders(params: PrincipalRolesControllerFindRoleHoldersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PrincipalRolesControllerFindRoleHoldersQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindRoleHolders401 | PrincipalRolesControllerFindRoleHolders403>, unknown>({ method : "GET", url : getPrincipalRolesControllerFindRoleHoldersUrl().url.toString(), params, ... requestConfig })  
  return res.data
}